import { Injectable } from "@angular/core";
import { FocusFieldStrategy } from "../directives/navigation-section.directive";
import { BaseNavigationStrategyService } from "./base-navigation-strategy.service";
import { NavigationService } from "./navigation.service";

@Injectable()
export class UpDownChangeSectionLeftRightChangeFieldNavigationStrategy extends BaseNavigationStrategyService {
    handleKeyPress(event: KeyboardEvent): void {
        if (NavigationService.LEFT_KEY.includes(event.keyCode)) { //sinistra
            this.moveToPreviousField(event);
        } else if (NavigationService.RIGHT_KEY.includes(event.keyCode)) { //destra
            this.moveToNextField(event);
        } else if (NavigationService.UP_KEY.includes(event.keyCode)) { //up
            this.moveToPreviousSection(FocusFieldStrategy.Last);
        } else if (NavigationService.DOWN_KEY.includes(event.keyCode)) { //down
            this.moveToNextSection(FocusFieldStrategy.First);
        }
    }
}
